<template>
  <div id="app">
    <group-chat></group-chat>
  </div>
</template>

<script>
// OGP タグをサーバサイドで書き出すためにAppを個別に作成
import GroupChat from '@/pages/chat/group/index.vue'

export default {
  name: 'app',
  components: {
    GroupChat
  }
}
</script>

<style src="./app.css">
</style>
